// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import moment from "moment";
import router from "./router";
import { ServerTable, ClientTable } from "vue-tables-2";

import JsonExcel from "vue-json-excel";
import VueAlertify from "vue-alertify";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import VueAxios from "vue-axios";
import axios from "axios";
import VModal from "vue-js-modal";
import VueSidebarMenu from "vue-sidebar-menu";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "vue-sidebar-menu/dist/vue-sidebar-menu.css";
import Router from "vue-router";
import { setupInterceptors } from "@/common/service/HttpInterceptors";
import { setupSysMsg } from "@/service/SysMsgService";
import styles from "../static/css/style.css";
import { store } from "./store";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faQuestionCircle,
  faQuestion,
  faHome,
  faDotCircle,
  faPlus,
  faEdit,
  faTrash,
  faUpload
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import vuetify from "@/plugins/vuetify"; // path to vuetify export
import VeeValidate from "vee-validate";
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
import { GlobalMixin } from "./common/mixin/GlobalMixin";
library.add(faQuestionCircle, faQuestion, faPlus, faEdit, faTrash, faUpload);

Vue.component("font-awesome-icon", FontAwesomeIcon);

// Install BootstrapVue
Vue.use(BootstrapVue);
Vue.use(VeeValidate, {
  validity: false,
  fieldsBagName: 'veeFields',
  errorBagName: "vErrors"
});
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
Vue.use(VueAlertify);
Vue.use(Router);
Vue.use(ClientTable);
Vue.use(ServerTable);
Vue.use(VueAxios, axios);
Vue.use(VModal);
Vue.use(VueSidebarMenu);
Vue.use(Viewer);
Vue.component("downloadExcel", JsonExcel);
Vue.config.productionTip = false;

//----Filters----
Vue.filter("toFixedDecimal", (value, length = 2) => {
  return value ? Number.parseFloat(value).toFixed(length).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,") : Number.parseFloat(0).toFixed(2);
});
Vue.filter("percent", value => {
  return value + "%";
});
Vue.filter("moment", (value, format) => {
  return value && moment(value).format(format) != "1900-01-01" ? moment(value).format(format) : "";
});

// Vue.mixin({
//   data() {
//     return GlobalMixin
//   }
// })

/* eslint-disable no-new */
setupInterceptors(store);
setupSysMsg(store).then(() => {
  new Vue({
    vuetify,
    el: "#app",
    router,
    store,
    components: { App },
    template: "<App/>"
  });
});



// WEBPACK FOOTER //
// ./src/main.js